import { BaseResAPI } from "@/@core/entity/res-api.entity";
import api from "@/api/axios";

export interface CreateWarehouseDTO {
  name: string;
  address: string;
  phone: string;
  pic_name: string;
  is_active: boolean;
}

export type CreateWarehouseResp = BaseResAPI<null>;

const createWarehouseInteractor = (
  params: CreateWarehouseDTO
): Promise<CreateWarehouseResp> => {
  const path = "/admin/warehouse";
  return api.post(path, params);
};

export default createWarehouseInteractor;
